import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PURCHASE_LINK } from '../utils/constants';
export function StickyBar() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show sticky bar after scrolling past the hero section (approx 600px)
      if (window.scrollY > 600) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-219">
      {isVisible && <motion.div initial={{
      y: 100
    }} animate={{
      y: 0
    }} exit={{
      y: 100
    }} className="fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-gray-200 shadow-[0_-4px_20px_rgba(0,0,0,0.1)] p-4 md:p-4" data-id="element-220">
          <div className="max-w-4xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-221">
            <div className="hidden md:block text-center md:text-left" data-id="element-222">
              <p className="font-black text-gray-900 text-lg" data-id="element-223">
                MEGA PACK INGLÉS
              </p>
              <p className="text-sm text-red-600 font-bold flex items-center gap-1" data-id="element-224">
                <span className="animate-pulse" data-id="element-225">🔥</span> Oferta por tiempo
                limitado
              </p>
            </div>

            <a href={PURCHASE_LINK} target="_blank" rel="noopener noreferrer" className="w-full md:w-auto flex-1 max-w-md bg-gradient-to-r from-orange-500 to-red-500 hover:from-orange-600 hover:to-red-600 text-white font-black text-xl py-3 px-8 rounded-xl text-center shadow-[0_4px_0_#c2410c] hover:shadow-[0_2px_0_#c2410c] hover:translate-y-[2px] transition-all uppercase tracking-wide" data-id="element-226">
              COMPRAR AHORA
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}